// extracted by mini-css-extract-plugin
module.exports = {"contact-us-info":"style_contact-us-info__QEL1a","title":"style_title__30JIy","info":"style_info__32yeE","email":"style_email__2zFzQ"};